import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { passwordRules } from "utils/passwordValidation";

/**
 * passwordRules (utils/passwordValidation) with its messages in the current language.
 * The checks themselves are passwordRules' own, so the two cannot drift apart.
 */
const usePasswordRules = () => {
  const { t } = useTranslation("account");
  return useMemo(
    () => ({
      required: t("validation.passwordRequired"),
      minLength: {
        value: passwordRules.minLength.value,
        message: t("password.rules.minLength"),
      },
      validate: Object.fromEntries(
        Object.entries(passwordRules.validate).map(([name, check]) => [
          name,
          (value) => check(value) === true || t(`password.rules.${name}`),
        ]),
      ),
    }),
    [t],
  );
};

export default usePasswordRules;
